ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})


//////////////////
// WEBPACK FOOTER
// ./node_modules/brace/snippets/json.js
// module id = 116
// module chunks = 0